import { call, put, takeLatest } from 'redux-saga/effects'
import { types, IGetGroupsAction } from '../types/groups'
import * as actions from '../actions/groups'
import * as services from '../services/groups'
import { trace } from '../services/common'

export function* getGroupsSaga(action?: IGetGroupsAction) {
  try {
    const list = yield call(services.getGroups)
    yield put(actions.getGroupsSuccess(list))
  } catch (err) {
    trace(err)
    yield put(actions.getGroupsFailure(err.message))
  }
}

export function* groupsWatcher() {
  yield takeLatest(types.GET_GROUPS__STARTED, getGroupsSaga)
}
